<app-menu></app-menu>
<div class="dateInfo-container" #consulta>
	<div class="navigation">
		<a [routerLink]="['../clinica']">
			<fa-icon [icon]="faArrowLeft"></fa-icon>
		</a>
		<div class="info">
			<h2>{{ especialidad }}</h2>
			<!-- <p>{{ hora }} - {{ fecha }}</p> -->
		</div>
	</div>

	<div class="doctor-container">
		<div class="doctor-profile">
			<div class="doctor-img">
				<fa-icon [icon]="faUserAlt"></fa-icon>
			</div>
			<h3 class="doctor-name">Informações fornecidas pelo paciente</h3>
			<div class="doctor-info">
				<p>Atualmente usa: {{medicamento}}</p>
				<br>
				<p>Tem alergia: {{alergia}}</p>
			</div>
		</div>

		<div class="doctor-recomendations">
			<div class="sintomas">
				<h5>Sintomas</h5>
				<br>
				<div class="list">
					<ul *ngFor="let sintoma of sintomas">
						<li>{{sintoma}}</li>
					</ul>
				</div>
			</div>
			<div class="recomendaciones" *ngIf="finalizada">
				<h5>Recomendações</h5>
				<br>
				<div class="list">
					<ul *ngFor="let recom of recomendaciones">
						<li>{{recom}}</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- <div class="doctor-recomendations" *ngIf="!finalizada">
			Esta cita todavía no ha sido realizada
		</div> -->
	</div>

	<button class="button" *ngIf="finalizada" (click)="generarPDF()">Baixe a receita em PDF</button>
</div>
